import { InfoPopupDialogState } from './info-popup-dialog.state';

/**
 * Initialer State für den Info-Popup-Dialog.
 */
export const infoPopupDialogStateInitial: InfoPopupDialogState = {
  isOpen: false,
  mode: undefined,
  previewData: undefined,
};
